<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Delete Question'"
    :submit-button-text="'DELETE'"
    :reset-modal="resetModal"
    :submit-modal="deleteQuestion"
  >
    <b-row v-if="question">
      <b-col>
        <p class="tsny_text">
          This action will delete the question
          <span class="font-weight-bold">{{ question.question }}</span> asked by
          <span class="font-weight-bold">{{ question.askedBy }}</span
          >. Please be absolutely certain you want to do this -- this action
          cannot be undone.
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        ><p class="tsny_status-text" v-if="deleteQuestionError">
          An error occurred deleting the course question
        </p></b-col
      >
    </b-row>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../TsnyModal";
import QuestionBankRestService from "../../services/rest/services/QuestionBankRestService";

export default {
  name: "DeleteQuestionModal",
  components: { TsnyModal },
  props: {
    question: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      modalId: "deleteQuestionModal",
      deleteQuestionError: null
    };
  },
  methods: {
    async deleteQuestion(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this;
      $comp.deleteQuestionError = false;

      try {
        await QuestionBankRestService.deleteQuestion($comp.question._id);
        $comp.$bvModal.hide($comp.modalId);
      } catch (err) {
        $comp.deleteQuestionError = true;
        console.log(err);
      }
    },
    resetModal: function() {
      this.deleteQuestionError = null;
    }
  }
};
</script>

<style scoped></style>
